import type { FormationManagementSearchParams } from './atoms';

export function formationManagementSearchToUrl(
  p: FormationManagementSearchParams
): string {
  const params = new URLSearchParams();
  if (p.page && p.page > 1) params.set('page', String(p.page));
  if (p.pageSize && p.pageSize !== 25)
    params.set('page_size', String(p.pageSize));
  if (p.text) params.set('text', p.text);
  if (p.basins?.length) params.set('basin', p.basins[0]!);
  if (p.intervals?.length) params.set('interval', p.intervals[0]!);
  if (p.creators?.length) params.set('creator', p.creators[0]!);
  if (p.created_at?.start) params.set('created_from', p.created_at.start);
  if (p.created_at?.end) params.set('created_to', p.created_at.end);
  if (p.updated_at?.start) params.set('updated_from', p.updated_at.start);
  if (p.updated_at?.end) params.set('updated_to', p.updated_at.end);
  if (p.sortAttribute) params.set('sort_attribute', p.sortAttribute);
  if (p.sortDirection) params.set('sort_direction', p.sortDirection);
  return params.toString();
}
